var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"products columns-4 seasidetms_products col-md-12"},_vm._l((_vm.products),function(product,index){return _c('product-tile',{key:product.slug,attrs:{"product":product,"detailsEnabled":false,"index":index}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }